import { RSAA } from 'redux-api-middleware';
import type { RSAACallAction, RSAACallRequest } from '@makemydeal/dr-react-18-wrappers';
import { FETCH_DEALERSHIPS_FAILURE, FETCH_DEALERSHIPS_REQUEST, FETCH_DEALERSHIPS_SUCCESS, RESET_DEALERSHIP } from './actions';

export const fetchDealerships = (bffEndpoint: string) => {
    const endpoint = `${bffEndpoint}`;

    const request: RSAACallRequest = {
        endpoint,
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        types: [FETCH_DEALERSHIPS_REQUEST, FETCH_DEALERSHIPS_SUCCESS, FETCH_DEALERSHIPS_FAILURE],
        fetch: async (input: RequestInfo | URL, init?: RequestInit) => await fetch(input, init)
    };
    return {
        [RSAA]: request
    } as RSAACallAction;
};

export const resetDealerships = () => ({
    type: RESET_DEALERSHIP
});
